import { useEffect, useState } from 'react';

import events from '~/modules/game-events/game-events';
import { useEventListener } from '~/modules/game-events/hooks';
import RemoteMicClient from '~/modules/remote-mic/network/client';

// This phone's own client id, as state rather than as a read off the client during render.
//
// `RemoteMicClient` is a mutable singleton, and the React Compiler treats a value read off one in
// render as constant for the life of the component - so a panel that rendered before the phone had
// registered kept showing no id for the rest of the session. Every panel is mounted from the first
// paint now, which is exactly the case that used to be avoided by building a tab when it was opened.
export default function useRemoteMicId() {
  const [connectionStatus] = useEventListener(events.karaokeConnectionStatusChange) ?? ['uninitialised'];
  const [id, setId] = useState<string | null>(null);

  useEffect(() => {
    setId(RemoteMicClient.getClientId());
  }, [connectionStatus]);

  return id;
}
